// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-text-input {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.custom-text-input.disabled .input-wrapper {
  background-color: #F9F9F9 !important;
}
.custom-text-input.disabled .input-wrapper input {
  color: #DFDFDF !important;
}
.custom-text-input label {
  font-weight: 600;
  font-size: 12px;
  color: #5F5F5F;
}
.custom-text-input .error-text, .custom-text-input .success-text {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
}
.custom-text-input .error-text {
  color: #EF4546;
}
.custom-text-input .success-text {
  color: #10B980;
}
.custom-text-input .input-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  align-content: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #F9F9F9;
  border: 1px solid #F9F9F9;
  transition: 0.2s all ease-in-out;
}
.custom-text-input .input-wrapper:focus-within {
  border-color: #949494;
  color: #5F5F5F;
}
.custom-text-input .input-wrapper:focus-within input {
  color: #5F5F5F;
}
.custom-text-input .input-wrapper:focus-within input::placeholder {
  font-weight: 400;
  color: #949494;
}
.custom-text-input .input-wrapper.large {
  padding: 14px;
}
.custom-text-input .input-wrapper.large input {
  font-size: 14px;
}
.custom-text-input .input-wrapper.small {
  padding: 4px;
}
.custom-text-input .input-wrapper.small input {
  font-size: 10px;
}
.custom-text-input .input-wrapper .left-slot {
  margin-left: 14px;
}
.custom-text-input .input-wrapper input {
  border: none;
  background-color: inherit;
  color: #949494;
  font-weight: 500;
  font-size: 12px;
  width: 100%;
  height: inherit !important;
  padding: 0 !important;
  border-radius: 0 !important;
}
.custom-text-input .input-wrapper input::placeholder {
  color: #949494;
}
.custom-text-input .input-wrapper input:focus {
  outline: none;
}
.custom-text-input .input-wrapper input::-webkit-outer-spin-button,
.custom-text-input .input-wrapper input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.custom-text-input .input-wrapper input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomTextInput/customTextInput.scss"],"names":[],"mappings":"AAkBA;EACI,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAjBJ;AAmBQ;EACI,oCAAA;AAjBZ;AAkBY;EACI,yBAAA;AAhBhB;AAoBI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAlBR;AAoBI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AAlBR;AAoBI;EAAc,cAjCJ;AAgBd;AAkBI;EAAgB,cAjCJ;AAkBhB;AAgBI;EACI,aAAA;EAEA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAnDG;EAoDH,yBAAA;EACA,gCAAA;AAfR;AAiBQ;EACI,qBArDS;EAsDT,cArDO;AAsCnB;AAiBY;EACI,cAxDG;AAyCnB;AAiBgB;EACI,gBAAA;EACA,cA1DK;AA2CzB;AAoBQ;EACI,aAAA;AAlBZ;AAoBY;EACI,eAAA;AAlBhB;AAsBQ;EACI,YAAA;AApBZ;AAsBY;EACI,eAAA;AApBhB;AAuBQ;EACI,iBAAA;AArBZ;AAuBQ;EACI,YAAA;EACA,yBAAA;EACA,cAzFC;EA0FD,gBAAA;EACA,eAAA;EACA,WAAA;EAGA,0BAAA;EACA,qBAAA;EACA,2BAAA;AAvBZ;AAyBY;EACI,cA/FS;AAwEzB;AA0BY;EACI,aAAA;AAxBhB;AA2BQ;;EAEI,wBAAA;EACA,SAAA;AAzBZ;AA4BQ;EACI,qBAAA;EACA,0BAAA;AA1BZ","sourcesContent":["$input-bg: #F9F9F9;\n$input-text: #949494;\n\n$input-focus-border: #949494;\n$input-focus-text: #5F5F5F;\n\n$input-placeholder-text: #949494;\n\n$input-error: #EF4546;\n$input-success: #10B980;\n\n$input-error-bg: #FEF2F2;\n$input-success-bg: #ECFDF5;\n\n$input-disabled-bg: #F9F9F9;\n$input-disabled-text: #DFDFDF;\n\n\n.custom-text-input {\n    font-family: 'Proxima Nova', sans-serif;\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n    &.disabled {\n        .input-wrapper{\n            background-color: $input-disabled-bg !important;\n            input { \n                color: $input-disabled-text !important;\n            }\n        }\n    }\n    label {\n        font-weight: 600;\n        font-size: 12px;\n        color: #5F5F5F;\n    }\n    .error-text, .success-text {\n        margin-top: 2px;\n        font-size: 12px;\n        font-weight: 400;\n    }\n    .error-text { color: $input-error; }\n    .success-text { color: $input-success; }\n    .input-wrapper {\n        display: flex;\n        // justify-content: space-between;\n        height: 100%;\n        align-items: center;\n        align-content: center;\n        padding: 10px;\n        border-radius: 8px;\n        background-color: $input-bg;\n        border: 1px solid $input-bg;\n        transition: .2s all ease-in-out;\n\n        &:focus-within {\n            border-color: $input-focus-border;\n            color: $input-focus-text;\n\n            input {\n                color: $input-focus-text;\n\n                &::placeholder {\n                    font-weight: 400;\n                    color: $input-placeholder-text;\n                }\n            }\n        }\n\n        &.large {\n            padding: 14px;\n\n            input {\n                font-size: 14px;\n            }\n        }\n\n        &.small {\n            padding: 4px;\n\n            input {\n                font-size: 10px;\n            }\n        }\n        .left-slot {\n            margin-left: 14px;\n        }\n        input {\n            border: none;\n            background-color: inherit;\n            color: $input-text;\n            font-weight: 500;\n            font-size: 12px;\n            width: 100%;\n\n            // TO BE REMOVED ONCE ALL INPUT IS CONVERTED TO COMPONENT\n            height: inherit !important;\n            padding: 0 !important;\n            border-radius: 0 !important;\n\n            &::placeholder {\n                color: $input-placeholder-text;\n            }\n\n            &:focus {\n                outline: none;\n            }\n        }\n        input::-webkit-outer-spin-button,\n        input::-webkit-inner-spin-button {\n            -webkit-appearance: none;\n            margin: 0;\n        }\n\n        input[type=number] {\n            appearance: textfield;\n            -moz-appearance: textfield;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
